// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__JRwZb","loaderOuter":"PageOverlayLoader_loaderOuter__qLSje"};